import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, CheckCircle2 } from "lucide-react";
import StarField from "../components/StarField";

export default function AboutPage({ t, NavbarComponent }) {
  const paragraphs = [t.about.lead, t.about.body, ...(t.about.story || [])];

  return (
    <div data-testid="about-page-root" className="min-h-screen bg-[#030508] text-white">
      {NavbarComponent}
      <main className="relative overflow-hidden pt-28 md:pt-32 pb-24">
        <div
          className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,184,0,0.12),transparent_30%),radial-gradient(circle_at_20%_20%,rgba(0,229,255,0.08),transparent_24%)]"
          aria-hidden="true"
        />
        <StarField count={38} />

        <article className="relative max-w-5xl mx-auto px-6 md:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] uppercase text-white/60 hover:text-[var(--primary)] transition-colors mb-8"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> {t.about.backHome}
          </Link>

          <header className="border border-white/10 bg-[#0b101e]/70 backdrop-blur-xl p-6 md:p-10 mb-8">
            <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--primary)] mb-5">
              {t.about.kicker}
            </div>
            <h1 className="font-display text-4xl md:text-6xl font-black uppercase leading-tight mb-6">
              <span className="block text-white">{t.about.title}</span>
              <span className="block text-[var(--primary)]">{t.about.titleAccent}</span>
            </h1>
            <p className="text-white/80 text-lg md:text-xl leading-relaxed max-w-3xl">
              {t.about.lead}
            </p>
          </header>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <section className="lg:col-span-8 border border-white/10 bg-white/[0.03] p-6 md:p-8">
              <div className="space-y-5 text-white/72 text-base md:text-lg leading-[1.85]">
                {paragraphs.slice(1).map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </section>

            <aside className="lg:col-span-4 space-y-4">
              {t.about.features.slice(0, 4).map((feature) => (
                <div key={feature.title} className="border border-white/10 bg-[#0b101e]/70 p-5">
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="h-5 w-5 text-[var(--primary)] mt-0.5 flex-shrink-0" />
                    <div>
                      <h2 className="font-display text-lg font-semibold text-white mb-1">
                        {feature.title}
                      </h2>
                      <p className="text-white/55 text-sm leading-relaxed">{feature.desc}</p>
                    </div>
                  </div>
                </div>
              ))}

              <Link
                to="/#platform"
                className="group inline-flex w-full items-center justify-between gap-3 border border-white/20 bg-white/[0.02] text-white font-mono text-[11px] tracking-[0.25em] uppercase font-semibold px-5 py-4 hover:border-[var(--primary)] hover:text-[var(--primary)] hover:bg-[var(--primary)]/5 transition-all"
              >
                <span>{t.about.backSection}</span>
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </aside>
          </div>
        </article>
      </main>
    </div>
  );
}
